module.exports = __webpack_public_path__ + "static/media/xslego-6-designSystem.133f2105.png";